import { render, staticRenderFns } from "./LanguageList.vue?vue&type=template&id=f1930582&scoped=true"
import script from "./LanguageList.vue?vue&type=script&lang=js"
export * from "./LanguageList.vue?vue&type=script&lang=js"
import style0 from "./LanguageList.vue?vue&type=style&index=0&id=f1930582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1930582",
  null
  
)

export default component.exports